var _asyncToGenerator = require("/home/runner/work/matzore_radio/matzore_radio/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (c) Crossbar.io Technologies GmbH and contributors
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////

var HAS_WHEN;
var when;
try {
  when = require('when');
  HAS_WHEN = true;
} catch (e) {
  HAS_WHEN = false;
}
var log = require('./log.js');

/// Convert base64 string to array of bytes.
function _atob(s) {
  if (s) {
    return new Uint8Array(atob(s).split("").map(function (c) {
      return c.charCodeAt(0);
    }));
  } else {
    return null;
  }
}
exports.atob = _atob;

/// Convert array of bytes to base64 string.
function _btoa(b) {
  if (b) {
    return btoa(String.fromCharCode.apply(null, b));
  } else {
    return null;
  }
}
exports.btoa = _btoa;

/// Convert array of bytes to hex string.
function _btoh(bytes) {
  if (bytes) {
    var res = '';
    for (var i = 0; i < bytes.length; ++i) {
      res += ('0' + (bytes[i] & 0xFF).toString(16)).slice(-2);
    }
    return res;
  } else {
    return null;
  }
}
exports.btoh = _btoh;

/// Convert hex string to array of bytes.
function _htob(hex) {
  if (hex) {
    if (typeof hex !== 'string') {
      throw new TypeError('Expected input to be a string');
    }
    if (hex.length % 2 !== 0) {
      throw new RangeError('Expected string to be an even number of characters');
    }
    var view = new Uint8Array(hex.length / 2);
    for (var i = 0; i < hex.length; i += 2) {
      view[i / 2] = parseInt(hex.substring(i, i + 2), 16);
    }
    return view;
  } else {
    return null;
  }
}
exports.htob = _htob;
var rand_normal = function rand_normal(mean, sd) {
  // Derive a Gaussian from Uniform random variables
  // http://en.wikipedia.org/wiki/Box%E2%80%93Muller_transform
  var x1, x2, rad;
  do {
    x1 = 2 * Math.random() - 1;
    x2 = 2 * Math.random() - 1;
    rad = x1 * x1 + x2 * x2;
  } while (rad >= 1 || rad == 0);
  var c = Math.sqrt(-2 * Math.log(rad) / rad);
  return (mean || 0) + x1 * c * (sd || 1);
};
var is_object = function is_object(variable) {
  return !Array.isArray(variable) && (variable instanceof Object || typeof variable === 'object');
};
var assert = function assert(cond, text) {
  if (cond) {
    return;
  }
  if (assert.useDebugger || 'AUTOBAHN_DEBUG' in global && AUTOBAHN_DEBUG) {
    debugger;
  }
  throw new Error(text || "Assertion failed!");
};

// Helper to do HTTP/POST requests returning deferreds. This function is
// supposed to work on IE8, IE9 and old Android WebKit browsers. We don't care
// if it works with other browsers.
//
var http_post = function http_post(url, data, timeout) {
  log.debug("new http_post request", url, data, timeout);
  var d = deferred_factory();
  var req = new XMLHttpRequest();
  req.withCredentials = true; // pass along cookies
  req.onreadystatechange = function () {
    if (req.readyState === 4) {
      // Normalize IE's response to HTTP 204 when Win error 1223.
      // http://stackoverflow.com/a/10047236/884770
      //
      var status = req.status === 1223 ? 204 : req.status;
      if (status === 200) {
        // response with content
        //
        d.resolve(req.responseText);
      }
      if (status === 204) {
        // empty response
        //
        d.resolve();
      } else {
        // anything else is a fail
        //
        var statusText = null;
        try {
          statusText = req.statusText;
        } catch (e) {
          // IE8 fucks up on this
        }
        d.reject({
          code: status,
          text: statusText
        });
      }
    }
  };
  req.open("POST", url, true);
  req.setRequestHeader("Content-type", "application/json; charset=utf-8");
  if (timeout > 0) {
    req.timeout = timeout; // request timeout in ms

    req.ontimeout = function () {
      d.reject({
        code: 501,
        text: "request timeout"
      });
    };
  }
  if (data) {
    req.send(data);
  } else {
    req.send();
  }
  if (d.promise.then) {
    // whenjs has the actual user promise in an attribute
    return d.promise;
  } else {
    return d;
  }
};

// Helper to do HTTP/GET requests returning JSON parsed result as a promise.
var http_get_json = function http_get_json(url, timeout) {
  var d = deferred_factory();
  var req = new XMLHttpRequest();
  req.withCredentials = true; // pass along cookies
  req.onreadystatechange = function () {
    if (req.readyState === 4) {
      // Normalize IE's response to HTTP 204 when Win error 1223.
      // http://stackoverflow.com/a/10047236/884770
      //
      var status = req.status === 1223 ? 204 : req.status;
      if (status === 200) {
        // parse response
        var data = JSON.parse(req.responseText);

        // response with content
        //
        d.resolve(data);
      }
      if (status === 204) {
        // empty response
        //
        d.resolve();
      } else {
        // anything else is a fail
        //
        var statusText = null;
        try {
          statusText = req.statusText;
        } catch (e) {
          // IE8 fucks up on this
        }
        d.reject({
          code: status,
          text: statusText
        });
      }
    }
  };
  req.open("GET", url, true);
  req.setRequestHeader("Content-type", "application/json; charset=utf-8");
  if (timeout > 0) {
    req.timeout = timeout; // request timeout in ms

    req.ontimeout = function () {
      d.reject({
        code: 501,
        text: "request timeout"
      });
    };
  }
  req.send();
  if (d.promise.then) {
    // whenjs has the actual user promise in an attribute
    return d.promise;
  } else {
    return d;
  }
};

/**
 * Merge a list of objects from left to right
 *
 * For each object passed to the function, add to the previous object the keys
 *     that are present in the former but not the latter. If the last argument
 *     is a boolean, it sets whether or not to recursively merge objects.
 *
 * This function mutates the first passed object. To avopid this, you can pass
 *     a new empty object as the first arg:
 *
 *     defaults({}, obj1, obj2, ...)
 *
 * @example
 *     defaults({ a: 1 }, { a: 2, b: 2 }, { b: 3, c: 3 })
 *     // { a: 1, b: 2, c: 3 }
 *
 *     defaults({ a: { k1: 1 } }, { a: { k2: 2 } })
 *     // { a: { k1: 1 } }
 *
 *     defaults({ a: { k1: 1 } }, { a: { k2: 2 } })
 *     // { a: { k1: 1 } }
 *
 * @param {Object} base The object to merge defaults to
 * @param {Object} source[, ...] The default values source
 * @param {Boolean} [recursive] Whether to recurse fro object values*
 *     (default: false)
 * @returns {Object} The mutated `base` object
 */
var defaults = function defaults() {
  // Return an empty object if no arguments are passed
  if (arguments.length === 0) return {};
  var base = arguments[0];
  var recursive = false;
  var len = arguments.length;

  // Check for recursive mode param
  if (typeof arguments[len - 1] === 'boolean') {
    recursive = arguments[len - 1];
    len -= 1; // Ignore the last arg
  }

  // Merging function used by Array#forEach()
  var do_merge = function do_merge(key) {
    var val = obj[key];

    // Set if unset
    if (!(key in base)) {
      base[key] = val;
      // If the value is an object and we use recursive mode, use defaults on
      // the value
    } else if (recursive && typeof val === 'object' && typeof base[key] === 'object') {
      defaults(base[key], val);
    }
    // Otherwise ignore the value
  };

  // Iterate over source objects
  for (var i = 1; i < len; i++) {
    var obj = arguments[i];

    // Ignore falsy values
    if (!obj) continue;

    // Require object
    if (typeof obj !== 'object') {
      throw new Error('Expected argument at index ' + i + ' to be an object');
    }

    // Merge keys
    Object.keys(obj).forEach(do_merge);
  }

  // Return the mutated base object
  return base;
};

/**
 * If an error handler function is given, it is called with the error instance, otherwise log the error to the console
 * with a possible custom error message prefix. The custom message is passed also the error handler.
 *
 * @param {function} handler - The error handler function.
 * @param {object | Error} error - The error instance.
 * @param {string} [error_message] - The custom error message, optional.
 */
var handle_error = function handle_error(handler, error, error_message) {
  if (typeof handler === 'function') {
    handler(error, error_message);
  } else {
    console.error(error_message || 'Unhandled exception raised: ', error);
  }
};

/**
 * Generate a new ID to identify a WAMP global scope entity, such as a session or a publication.
 * Represented as a JavaScript Number (double float), so ensure that an appropriate serialization
 * for an integer is used for use in transported WAMP protocol messages.
 */
var new_global_id = function new_global_id() {
  return Math.floor(Math.random() * 9007199254740992) + 1;
};
var deferred_factory = function deferred_factory(options) {
  var defer;

  // Our strategy is to default to whenjs-based promise if a promise
  // preference is not provided *and* whenjs is available.
  // In the absence of whenjs and promise preference, we
  // use the ES6 Promise because we are ES6+ so always expect
  // that to be available.

  var get_es6_promise_factory = function get_es6_promise_factory() {
    return function () {
      var deferred = {};
      deferred.promise = new Promise(function (resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
      });
      return deferred;
    };
  };
  if (options) {
    if (options.use_es6_promises) {
      // ES6-based deferred factory
      //
      defer = get_es6_promise_factory();
    } else if (options.use_deferred) {
      // use explicit deferred factory, e.g. jQuery.Deferred or Q.defer
      //
      defer = options.use_deferred;
    } else if (HAS_WHEN) {
      // whenjs-based deferred factory
      //
      defer = when.defer;
    } else {
      // ES6-based deferred factory
      //
      defer = get_es6_promise_factory();
    }
  } else if (HAS_WHEN) {
    // whenjs-based deferred factory
    //
    defer = when.defer;
  } else {
    // ES6-based deferred factory
    //
    defer = get_es6_promise_factory();
  }
  return defer;
};
var promise = function promise(d) {
  if (d.promise.then) {
    // whenjs has the actual user promise in an attribute
    return d.promise;
  } else {
    return d;
  }
};
var sleep = /*#__PURE__*/function () {
  var _sleep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ms) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              return setTimeout(resolve, ms);
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  function sleep(_x) {
    return _sleep.apply(this, arguments);
  }
  return sleep;
}();
var _read_file = /*#__PURE__*/function () {
  var _read_file2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(path) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              fs.readFile(path, function (err, data) {
                if (err) {
                  reject(err);
                } else {
                  resolve(data);
                }
              });
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  function read_file(_x2) {
    return _read_file2.apply(this, arguments);
  }
  return read_file;
}();
var as_promise = function as_promise(func) {
  var _this = this;
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return new Promise(function (resolve, reject) {
    try {
      resolve(func.call.apply(func, [_this].concat(args)));
    } catch (e) {
      reject(e);
    }
  });
};
if ('fs' in global) {
  exports.read_file = _read_file;
} else {
  exports.read_file = null;
}
exports.handle_error = handle_error;
exports.rand_normal = rand_normal;
exports.is_object = is_object;
exports.assert = assert;
exports.http_post = http_post;
exports.http_get_json = http_get_json;
exports.defaults = defaults;
exports.new_global_id = new_global_id;
exports.deferred_factory = deferred_factory;
exports.promise = promise;
exports.sleep = sleep;
exports.as_promise = as_promise;